import { CreatorBrand } from 'constants/brands';
import React from 'react';
import { AuthenticatedActions } from 'types';
import { t } from '@lingui/macro';
import { usePrivateAction } from 'hooks/usePrivateAction';

const useShareCreatorButton = ({
    onClick,
}: {
    onClick?: () => void;
}): {
    handleClick: (event: React.MouseEvent) => void;
} => {
    const doPrivateAction = usePrivateAction();

    const handleClick = (): void => {
        doPrivateAction({
            handleAuthenticated: onClick,
            actionDescription: {
                type: AuthenticatedActions.creatorShareTrack,
                description: t`share your ${CreatorBrand} track`,
                args: [],
            },
        });
    };

    return {
        handleClick,
    };
};

export default useShareCreatorButton;
